// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.click_upload[data-v-64881770]{\n  color: #1a96d4;\n  font-style: normal;\n  font-size: 14px;\n}\n.bright_icon[data-v-64881770]{\n  color: #1a96d4;\n}\n.img_div[data-v-64881770]{\n  position: relative;\n}\n.img_name[data-v-64881770]{\n  display: block;\n  background: rgba(204, 204, 204, .8);\n  color: #fff;\n  padding: 0 2px;\n  text-overflow : ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  position: absolute;\n  bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
